import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { apiSearch } from '../modules/utility';

const apiBase = 'shift';

const search = (p = {}) => {
	const { callback = _.noop } = p;
	return dispatch => {
		apiSearch({
			base : apiBase,
			dispatch,
			callback,
		});
	};
};

const mapStateToProps = (state, ownProps) => {
	//- Get a single shift and the list of shifts
	const shiftId = (ownProps.shiftId)
		? ownProps.shiftId
		: _.get(ownProps, ['match', 'params', 'shiftId']);
	const shift = _.get(state.maps, ['shift', shiftId]);

	let shifts = [];
	if (state.lists.shiftIds) {
		shifts = _.map(state.lists.shiftIds, id => state.maps.shift[id]);
	}

	return {
		shift,
		shifts,
	};
};

const mapDispatchToProps = dispatch => bindActionCreators({
	searchShifts : search,
}, dispatch);

export default connect(
	mapStateToProps,
	mapDispatchToProps
);
